import React from 'react';
import styled from 'styled-components';
import useLanguage from '../../../../utilities/useLanguage';
import { getTranslation } from "../../translations";

export interface IOtherDetailsProps {
    header: string,
    label: string,
}

const OtherDetailsInner = styled.div`
    width: 416px;
    max-width: 100%;

    small {
        display: block;
    }
`;

const OtherDetails = ({ header, label }: IOtherDetailsProps) => {
    const { lang } = useLanguage();
    return (
        <div className='d-none d-md-flex justify-content-end mt-6 pr-5'>
            <OtherDetailsInner>
                <h3 className="mb-2 text-dark">{header}</h3>
                <small className="mb-2">{label}</small>
                <small>
                    <a className="text-underline" href="https://www.macu.com/loans/home-loans/meet-with-a-mortgage-loan-officer">{getTranslation(lang).meetWithMortgageExpertToLearnMore}</a>
                </small>
            </OtherDetailsInner>
        </div>
    )
};

export default OtherDetails;
